import { render, staticRenderFns } from "./StockPlacePicker.vue?vue&type=template&id=1b16c548&scoped=true&"
import script from "./StockPlacePicker.vue?vue&type=script&lang=js&"
export * from "./StockPlacePicker.vue?vue&type=script&lang=js&"
import style0 from "./StockPlacePicker.vue?vue&type=style&index=0&id=1b16c548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b16c548",
  null
  
)

export default component.exports